
export const zIndexDict = {
  landingBG: -1,
  landingStyle: 0,
  landingBlur: 1,
  overLandingBlur: 2
}
